import { User } from "../../../user";
import { Department } from "../../../department";
import { IHisInformationApplicable } from "../../../document/items";
import {
  DefaultDepartmentBehavior,
  DefaultUserBehavior,
  DoctorBehavior,
  HisInfoListItemBehavior,
  IHisInfoGroupBehavior,
  UserKanaNameBehavior,
} from "./";
import {
  IHisInformationGroupSource,
  HisInformationUserGroupSource,
  HisInformationDepartmentGroupSource,
  HisInformationListItemGroupSource
} from "../HisInformationGroupSource";

export class HisInfoUserGroupInputBehaviorFactory {
  private static readonly _userGroupDictionary: { [key: string]: (users: User[], department?: Department) => IHisInfoGroupBehavior } = {
    CREATE_USER: (users: User[], department: Department) => new DoctorBehavior("CREATE_USER", users, department),
    DOCTOR: (users: User[], department: Department) => new DoctorBehavior("DOCTOR", users, department),
    DOCTOR_SELECT: (users: User[], department: Department) => new DoctorBehavior("DOCTOR_SELECT", users, department),
    USER_KANA_NAME: (users: User[]) => new UserKanaNameBehavior(users),
  };

  static create(item: IHisInformationApplicable, source: IHisInformationGroupSource): IHisInfoGroupBehavior {
    if (source instanceof HisInformationUserGroupSource) {
      const creater = this._userGroupDictionary[item.hisItemParameter.key];
      if (creater != null) { return creater(source.data, source.department); }

      return new DefaultUserBehavior(item.hisItemParameter.key, source.data);
    }
    if (source instanceof HisInformationDepartmentGroupSource) {
      return new DefaultDepartmentBehavior(item.hisItemParameter.key, source.data);
    }
    if (source instanceof HisInformationListItemGroupSource) {
      return new HisInfoListItemBehavior(item, source.data);
    }
  }
}
